import React from "react";
import { EndCustomer } from "@api/graphql/generated/generated-types";
import { CommentList } from "./components/CommentList";
import { CommentInput } from "./components/CommentInput";
import { useAddComment } from "./hooks/useAddComment";

interface Props {
  endCustomer: EndCustomer;
  onCommentAdded: () => void;
}

export function CustomerAccountComments({ endCustomer, onCommentAdded }: Props) {
  const { addComment, loading } = useAddComment(endCustomer.courierId, endCustomer.id, onCommentAdded);
  const comments = endCustomer.accountComments ?? [];

  return (
    <div className="flex flex-col gap-3">
      <CommentList comments={comments} />
      <CommentInput onSubmit={addComment} loading={loading} />
    </div>
  );
}
